import { useEffect } from "react";

export default function useKeyboardNavigation(openEPG, closeEPG) {
  useEffect(() => {
    const OPEN = new Set(["Enter", "ArrowUp"]);
    const CLOSE = new Set(["Back", "Backspace", "BrowserBack", "Escape"]);

    let rafId = null;
    let pending = null; 

    const flush = () => {
      rafId = null;
      const a = pending;
      pending = null;
      if (a === "close") closeEPG();
      else if (a === "open") openEPG();
    };

    const handle = (e) => {

      if (CLOSE.has(e.key)) {
        if (e.key === "Backspace") e.preventDefault?.(); 
        pending = "close"; 
      } else if (OPEN.has(e.key)) {
        if (pending !== "close") pending = "open";
      } else return;

      if (rafId == null) rafId = requestAnimationFrame(flush);
    };

    window.addEventListener("keydown", handle, { capture: true, passive: false });
    return () => {
      window.removeEventListener("keydown", handle, { capture: true });
      if (rafId != null) cancelAnimationFrame(rafId);
    };
  }, [openEPG, closeEPG]);
}
